import {createSvgIcon} from '../create-svg-icon';

export const SubdirectoryArrowRightIcon = createSvgIcon(
  <path d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
, 'SubdirectoryArrowRightOutlined');
